"use client"

import { Component } from "react"
import moment from "moment"
import * as XLSX from 'xlsx'
import { URL_PATH } from "../../services/API"
import API from "../../services/API"
import redux from "../../common/Redux"
import Table from "../../components/Table"
import Header from "../../components/Header"
import Modal from "../../components/Modal"
import Toast from "../../components/Toast"
import { root_url } from "../../services/API"
import Button from "@mui/material/Button"
import routes from "../../routes/URL";


class MainScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      version: 1,
      loading: true,
      error: null,
      modleVisible: false,
      modalData: null,
      orderData: null,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    this.getAllUsers()
  }

  getAllUsers = async () => {
    const { status, data } = await API(this, "get", URL_PATH.listAllUsers(this.props.selectedHotelId.id))
    console.log("Users data loaded", data)
  }

  handleToastClose = () => {
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  onEdit = (item) => {
    console.log("Edit user:", item)
  }

onView = async (item) => {
  try {
    this.setState({ loading: true })

    const token = localStorage.getItem("token")
    const requestBody = {
      hotel_id: this.props.selectedHotelId.id,
      user_id: item.user_id,
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    }

    const { status, data } = await API(
      this,
      "post",
      `${root_url}/api/hotelowner/hotel/customers/viewOrders`,
      requestBody,
      headers,
    )

    if (status && data) {
      // Navigate to customer detail screen with data
      console.log("customerslug",item.slug)
      this.props.history.push(routes.admin.customers.view(this.props.hotels[0].hotel_slug,item.user_slug), {
        modalData: item,
        orderData: data,
        selectedHotelId: this.props.selectedHotelId,
      })
    } else {
      this.showToast("Failed to fetch order data", "error")
    }
  } catch (error) {
    console.error("Error fetching order data:", error)
    this.showToast("An error occurred while fetching order data", "error")
  } finally {
    this.setState({ loading: false })
  }
}

exportCurrentUserOrders = () => {
  const { orderData, modalData } = this.state;
  
  if (!orderData || !orderData.data || orderData.data.length === 0) {
    this.showToast("No order data to export", "warning");
    return;
  }

  // Prepare customer info section
  const customerInfo = [
    ["Customer Details", ""],
    ["Name", modalData.user_name],
    ["Email", modalData.user_email],
    ["Phone", modalData.user_phone],
    ["Total Orders", orderData.data.length],
    ["", ""], // Empty row
    ["Order History", ""]
  ];

  // Prepare order headers + rows
  const orderHeaders = [
    "Order ID", 
    "Date", 
    "Type", 
    "Status", 
    "Payment Method", 
    "Total Amount (₹)", 
    "Discount (₹)", 
    "Tax (₹)", 
    "Subtotal (₹)"
  ];

  const orderRows = orderData.data.map(order => [
    order.id,
    moment(order.order_date_time).format("DD-MM-YYYY HH:mm"),
    order.order_type,
    order.order_status,
    order.payment_method || "N/A",
    Number.parseFloat(order.order_grand_total).toFixed(2),
    Number.parseFloat(order.discount || 0).toFixed(2),
    Number.parseFloat(order.tax || 0).toFixed(2),
    Number.parseFloat(order.subtotal || 0).toFixed(2),
  ]);

  // Calculate total grand total
  const totalAmount = orderData.data.reduce((sum, order) => sum + Number(order.order_grand_total), 0);

  // Add summary row
  const summaryRow = ["TOTAL", "", "", "", "", totalAmount.toFixed(2), "", "", ""];

  // Combine everything
  const exportData = [
    ...customerInfo,
    orderHeaders,
    ...orderRows,
    summaryRow
  ];

  // Create worksheet
  const ws = XLSX.utils.aoa_to_sheet(exportData);

  // Convert worksheet to CSV
  const csv = XLSX.utils.sheet_to_csv(ws, { FS: ",", RS: "\n" });

  // Create Blob and trigger download
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const fileName = `${modalData.user_name.replace(/\s+/g, '_')}_Orders_${moment().format('YYYYMMDD')}.csv`;

  if (navigator.msSaveBlob) { // for IE
    navigator.msSaveBlob(blob, fileName);
  } else {
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  this.showToast("Order history exported as CSV successfully", "success");
};


  Row = ({ label, value }) => {
    return (
      <div style={{ display: "flex", marginBottom: "10px" }}>
        <div style={{ fontWeight: "bold", width: "200px" }}>{label}:</div>
        <div>{value || "N/A"}</div>
      </div>
    )
  }

  render() {
    const { modalData, modleVisible, orderData, toast } = this.state

    return (
      <div className="container-fluid">
        <Header title="Customers" />

        <Table
          key={this.state.version}
          export={true}
          api={URL_PATH.listAllUsers(this.props.selectedHotelId.id)}
          searchPlaceholder="Search by name"
          onView={this.onView}
            exportFileName="Customers"  

          deleteText="Delete User will remove all associated data"
          row={[
            { title: "Name", key: "user_name", sortable: true },
            { title: "Mobile No", key: "user_phone", sortable: true },
            { title: "Email", key: "user_email", sortable: true },
            { title: "Orders", key: "total_orders", sortable: true },
          ]}
        />

        {modleVisible && modalData && orderData && (
          <Modal
            visible={modleVisible}
            onClose={() => {
              this.setState({
                modleVisible: false,
                orderData: null,
              })
            }}
            title={`Orders for ${modalData.user_name}`}
            width="100%"
            footer={
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.exportCurrentUserOrders}
                  disabled={!orderData.data || orderData.data.length === 0}
                  sx={{
                    px: 4,
                    py: 1,
                    borderRadius: 1,
                    textTransform: "none",
                    fontWeight: 700,
                    bgcolor: "#FFC857",
                    color: "#000",
                    "&:hover": { bgcolor: "#E6B54E" },
                  }}
                >
                  Export to Excel
                </Button>
              </div>
            }
          >
            <div
              style={{
                padding: "15px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                maxHeight: "70vh",
                overflowY: "auto",
              }}
            >
              {orderData.data && orderData.data.length > 0 ? (
                <table className="table">
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      <th>Date</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Payment</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderData.data.map((order) => (
                      <tr key={order.id}>
                        <td>{order.id}</td>
                        <td>{moment(order.order_date_time).format("DD-MM-YYYY HH:mm")}</td>
                        <td>{order.order_type}</td>
                        <td>
                          <span
                            style={{
                              backgroundColor: order.order_status === "completed" ? "#00A651" : "#FFC857",
                              color: order.order_status === "completed" ? "white" : "black",
                              padding: "4px 8px",
                              borderRadius: "12px",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            {order.order_status}
                          </span>
                        </td>
                        <td>{order.payment_method || "N/A"}</td>
                        <td>₹{Number.parseFloat(order.order_grand_total).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <p>No orders found for this user.</p>
                </div>
              )}

              {/* {orderData.total > 0 && (
                <div style={{ marginTop: "15px" }}>
                  <p>
                    Showing {orderData.from} to {orderData.to} of {orderData.total} orders
                  </p>
                </div>
              )} */}
            </div>
          </Modal>
        )}

        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={this.handleToastClose}
        />
      </div>
    )
  }
}

export default redux(MainScreen)